export enum StorageKeys {
  authTokens = 'authTokens',
  userRole = 'userRole',
}

export enum HeaderType {
  ACCESS = 'ACCESS',
  REFRESH = 'REFRESH',
}

export enum UserRoles {
  EMPLOYEE = 'employee',
  ADMIN = 'admin',
}

export enum MediaCategory {
  VIDEO = 'video',
  IMAGE = 'image',
  AUDIO = 'audio',
}

export enum PaymentStatus {
  ALL = 'All',
  PAID = 'Paid',
  NOT_PAID = 'Not Paid',
}
